'use client'

import { useCallback } from 'react'
import { Input, LoadableComponentProps } from 'ui'

import { useClientSearchParams } from '@/hooks/useClientSearchParams'
import { useUrlValidation } from '@/hooks/useUrlValidation'

import { useIngredientsPageSearchQuery } from './store'

type SearchBarProps = LoadableComponentProps<{
  label: string
}>

export default function SearchBar({ loading, data }: SearchBarProps) {
  const { searchQuery, setSearchQuery } = useIngredientsPageSearchQuery()

  const onQueryChange = useCallback(
    (query: string) => {
      setSearchQuery(query)

      const currentUrl = new URL(location.href)
      const newSearchParams = new URLSearchParams(currentUrl.search)

      if (query.length === 0) {
        newSearchParams.delete('s')
      } else {
        newSearchParams.set('s', query)
      }

      const searchParams = newSearchParams.toString()

      history.replaceState(
        null,
        '',
        `${location.pathname}${searchParams.length === 0 ? '' : `?${searchParams}`}`,
      )
    },
    [setSearchQuery],
  )

  const clientSearchParams = useClientSearchParams()

  useUrlValidation({
    searchParams: clientSearchParams,
    searchParamsCheckRules: [
      {
        key: 's',
        onSuccess: setSearchQuery,
      },
    ],
  })

  return (
    <Input
      rounded
      withMagnifier
      loading={loading}
      label={data?.label}
      value={searchQuery}
      onChange={onQueryChange}
    />
  )
}
